import { throttle } from './helpers/throttle.js';

let navClearTimer;
function scrollNavClass () {
	if (document.body.scrollTop > 80 || document.documentElement.scrollTop > 80) {
		document.body.classList.add('js-nav-clear');

	} else {
		document.body.classList.remove('js-nav-clear');
	}
}

window.addEventListener('scroll', function() {
	throttle(scrollNavClass, navClearTimer, 250);
});




